import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import { Milestone } from "./milestonesTypes";

const statusLabels: Record<Milestone["status"], string> = {
  not_started: "Not started",
  in_progress: "In progress",
  complete: "Complete",
};

interface MilestoneCardProps {
  milestone: Milestone;
  onEdit: (milestone: Milestone) => void;
  onDelete: (milestone: Milestone) => void;
  onMarkComplete: (milestone: Milestone) => void;
}

export function MilestoneCard({
  milestone,
  onEdit,
  onDelete,
  onMarkComplete,
}: MilestoneCardProps) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {milestone.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Target date: {milestone.target_date || "Not set"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Weight: {milestone.percentage_of_project}%
            </Typography>
            {milestone.completion_date && (
              <Typography variant="body2" color="text.secondary">
                Completed: {milestone.completion_date}
              </Typography>
            )}
          </Box>
          <Chip
            label={statusLabels[milestone.status]}
            color={
              milestone.status === "complete"
                ? "success"
                : milestone.status === "in_progress"
                  ? "warning"
                  : "default"
            }
            variant="outlined"
          />
        </Stack>
      </CardContent>
      <CardActions sx={{ justifyContent: "space-between" }}>
        <Box>
          {milestone.status !== "complete" && (
            <Button
              size="small"
              startIcon={<CheckCircleIcon />}
              onClick={() => onMarkComplete(milestone)}
            >
              Mark complete
            </Button>
          )}
        </Box>
        <Box>
          <Tooltip title="Edit milestone">
            <IconButton onClick={() => onEdit(milestone)}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete milestone">
            <IconButton color="error" onClick={() => onDelete(milestone)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </CardActions>
    </Card>
  );
}
